// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__11Cif","inner":"Footer_inner__3E0DH"};